/**
 * Animated background orbs for auth pages.
 */
export function AuthBackdrop() {
  return (
    <>
      <div className="hero-orb top-16 left-10 h-24 w-24 bg-primary-500/20 animate-float" />
      <div className="hero-orb bottom-24 right-16 h-28 w-28 bg-accent-cyan/20 animate-float" />
      <div className="hero-orb top-1/3 right-1/4 h-16 w-16 bg-accent-amber/20 animate-float" />
    </>
  );
}
